module.exports = __webpack_public_path__ + "static/media/edu3.e0b1059c.jpg";